const Product = () => {
    return (
    <div className="container">

      <h1>Product Gallery</h1>
      <div className="contentsGroup2">
        <p className="boldText center">Mucksucker Drum Dust Vacuum Extraction Unit</p>
        <img alt="mainProduct" className="imgContain" src={require('./prod-gal-router-300.jpg')} />


            <a className="center button" href='./productinfo?product=1'>More Info</a>

            <p className="boldText center">
                We're proud of how our machines look, the trollies and bins are strong and useful and the parts that look smart are the technical parts.
            </p>
            <p className="boldText center">
                A range of accessories are available including extension hoses, extra floor cleaning kit etc. 
            </p>
            <p className="boldText center">
                MuckSucker 1200W CNC Dust Extraction Unit with (2) Metal Bins
            </p>
            
            <a className="center button" href='./shoplist'>View All</a>
        </div>    

    </div>    
    );
  };
  
  export default Product;